module.exports = __webpack_public_path__ + "img/sosial2.7537a14a.svg";